import { Authority } from '@/openapi';
import React from 'react';

export interface AuthContextType {
	token?: string;
	isLoggedIn: boolean;
	isLoading: boolean;
	userId?: number;
	email?: string;
	username?: string;
	role?: Authority[];
	closedContracts?: number;
	login: (token: string) => void;
	logout: () => void;
}

export const AuthContext = React.createContext<AuthContextType>({
	token: undefined,
	isLoggedIn: false,
	isLoading: true,
	userId: undefined,
	email: undefined,
	username: undefined,
	role: undefined,
	closedContracts: undefined,
	login: () => {},
	logout: () => {}
});
